import { createSelector } from '@ngrx/store'

export const getUpdateBuildingState = createSelector(
  (state: any) => state.digitization,
  (state: any) => state.get('updateBuilding'),
)
